<template>
  <div id="passwd_hint_content" class="password-validation" v-show="isValid == 'fail'">
    <ul>
      <li>
        <span>{{ $t("passwd_condition") }}</span>
      </li>
      <li>
        <ul>
          <li>
            <div class="pwd-checkbox" :class="{ checked: check.uppercase }"></div>
            <span>{{ $t("password_reset_conditions1") }}</span>
          </li>
          <li>
            <div class="pwd-checkbox" :class="{ checked: check.lowercase }"></div>
            <span>{{ $t("password_reset_conditions2") }}</span>
          </li>
          <li>
            <div class="pwd-checkbox" :class="{ checked: check.number }"></div>
            <span>{{ $t("password_reset_conditions3") }}</span>
          </li>
          <li>
            <div class="pwd-checkbox" :class="{ checked: check.special }"></div>
            <span v-html="$t('password_allow_special_char')"></span>
          </li>
          <li>
            <div class="pwd-checkbox" :class="{ checked: reachCondition }"></div>
            <span>{{ $t("password_complex_need") }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    password: {
      type: String,
      default: "",
    },
    valid: {
      type: String,
      default: "init",
    },
  },
  data() {
    return {
      check: {
        len: false,
        uppercase: false,
        lowercase: false,
        number: false,
        special: false,
      },
      init: true,
    };
  },
  computed: {
    reachCondition() {
      let count = 0;

      if (this.check.uppercase) count++;
      if (this.check.lowercase) count++;
      if (this.check.number) count++;
      if (this.check.special) count++;
      if (this.check.len) count++;

      return count >= 5;
    },
    isValid() {
      if (this.init || this.password == "") {
        return "init";
      }
      if (this.reachCondition) {
        return "pass";
      } else {
        return "fail";
      }
    },
  },
  watch: {
    password: {
      handler(newValue) {
        const pwd = newValue;
        if (typeof pwd === "undefined") return;
        if (pwd != "" && this.init) {
          this.init = false;
        }

        this.check.len = pwd.length >= 8 && pwd.length <= 32;
        this.check.uppercase = pwd != "" && new RegExp("[A-Z]").test(pwd);
        this.check.lowercase = pwd != "" && new RegExp("[a-z]").test(pwd);
        this.check.number = pwd != "" && new RegExp("[0-9]").test(pwd);
        this.check.special = pwd != "" && new RegExp("((?=[\x21-\x7e]+)[^A-Za-z0-9])").test(pwd);
        this.$emit("update:valid", this.isValid);
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.password-validation {
  margin-bottom: 10px;
  background: #f0eceb;
  border-radius: 20px;
  display: inline-block;
  margin-left: 45%;
  ul {
    margin: 10px 22px;
    padding-left: 0;
    width: auto;
    li {
      list-style-type: none;
      text-align: left;
    }
  }
  .pwd-checkbox {
    width: 20px;
    height: 20px;
    background: url("~images/checkbox-selected-gry.svg");
    display: inline-block;
    margin-right: 5px;
  }
  .pwd-checkbox.checked {
    background: url("~images/checkbox-selected.svg");
  }
}
</style>
